import { render, staticRenderFns } from "./submitteInfo.vue?vue&type=template&id=70935db0&scoped=true&"
import script from "./submitteInfo.vue?vue&type=script&lang=js&"
export * from "./submitteInfo.vue?vue&type=script&lang=js&"
import style0 from "./submitteInfo.vue?vue&type=style&index=0&id=70935db0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70935db0",
  null
  
)

export default component.exports